var _path, _circle, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg08Sea(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 40,
    viewBox: "0 0 33 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1317 32.0569C22.2467 31.8556 22.4289 31.7015 22.6437 31.6143C28.5006 29.2376 32.6309 23.4924 32.6309 16.7826C32.6309 7.94601 25.4674 0.782562 16.6309 0.782562C7.7943 0.782562 0.630859 7.94601 0.630859 16.7826C0.630859 23.5786 4.86792 29.385 10.8445 31.7042C11.0658 31.7901 11.2537 31.9465 11.3714 32.1526L14.9878 38.4811C15.7555 39.8247 17.6929 39.8247 18.4607 38.4811L22.1317 32.0569Z",
    fill: "#5746C0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.6309,
    cy: 16.7826,
    r: 13.5,
    fill: "#291F50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8442 10.2822L23.5566 9.9946C23.3978 9.83576 23.1274 9.84864 22.9527 10.0234L10.9312 22.0448C10.7565 22.2195 10.7436 22.4899 10.9025 22.6488L11.1901 22.9363C11.3489 23.0952 11.6193 23.0823 11.794 22.9076L23.8155 10.8861C23.9902 10.7114 24.0031 10.441 23.8442 10.2822Z",
    fill: "#E7E6F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0308 19.671L15.9074 17.0688L19.9382 13.0379L20.801 13.9007L15.0308 19.671Z",
    fill: "#ABA9C8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8621 10.1856L14.738 13.0615V13.0615C14.3701 13.4295 13.7735 13.4295 13.4055 13.0615L11.8621 11.518C11.4941 11.1501 11.4941 10.5535 11.8621 10.1856V10.1856Z",
    fill: "#4841A6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4897 18.8134L23.3657 21.6894V21.6894C22.9977 22.0573 22.4012 22.0573 22.0332 21.6894L20.4897 20.1459C20.1218 19.7779 20.1218 19.1814 20.4897 18.8134V18.8134Z",
    fill: "#E7E6F0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7378 13.0615L20.4869 18.8106V18.8106C20.1189 19.1785 19.5224 19.1785 19.1544 18.8106L14.7378 14.394C14.3698 14.026 14.3698 13.4294 14.7378 13.0615V13.0615Z",
    fill: "#8F87F3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7837 10.7675C22.7837 10.7675 23.2208 16.1053 20.4858 18.823L23.3589 21.6961C26.5368 18.5182 25.9616 13.9454 22.7837 10.7675Z",
    fill: "#4841A6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7836 10.7675C19.6057 7.5896 15.0301 7.01728 11.855 10.1923L14.7281 13.0654C17.443 10.3275 22.7836 10.7675 22.7836 10.7675Z",
    fill: "#8F87F3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6014 15.9386L14.7284 13.0655C17.4433 10.3276 22.7781 10.7619 22.7781 10.7619L17.6014 15.9386ZM22.7813 10.77L22.7837 10.7676L22.7808 10.7647C22.7808 10.7647 22.781 10.7665 22.7813 10.77ZM22.7813 10.77L17.607 15.9443L20.4772 18.8145L20.483 18.8202C23.1707 16.1551 22.7959 10.9595 22.7813 10.77Z",
    fill: "#E7E6F0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg08Sea);
export default __webpack_public_path__ + "static/media/08_sea.617c715fb8bd3895c07fdf5ad1e919ed.svg";
export { ForwardRef as ReactComponent };